<template>
    <Materials></Materials>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const Materials = defineAsyncComponent(() =>
    import("../../components/Design/Materials.vue")
);

export default {
    name: "MaterialsPage", //The name you are in should not equal the name of the component you are importing.
    components: { Materials, AuthLayout },
};
</script>
